// @flow
import React, { Fragment } from 'react';
import MainMobileHeadContainer from 'containers/main/MainMobileHeadContainer';
import MainHeadContainer from 'containers/main/MainHeadContainer';
import MainMobileFooter from 'components/main/MainMobileFooter';
import PageTemplate from "components/base/PageTemplate";
import { Link } from 'react-router-dom';
import './ErrorInfo.scss';

type Props = {
  message?: string,
  code?: string | number,
};

const ErrorInfo = ({ code, message }: Props) => {
  return (
    <PageTemplate>
      <header>
        <MainHeadContainer />
        <MainMobileHeadContainer />
      </header>
      <div className="ErrorInfo">
        <div className="min">
          {code !== '' && <div className="code">{code}</div>}
          <div className="message">{message}</div>
          <Link className="gohome" to="/">
            홈으로
          </Link>
        </div>
      </div>
      <MainMobileFooter />
    </PageTemplate>
  );
};

ErrorInfo.defaultProps = {
  message: '오류가 발생했습니다',
  code: '',
};

export default ErrorInfo;



// WEBPACK FOOTER //
// ./src/components/etc/ErrorInfo/ErrorInfo.js